import {
	TableRow as TableRowMui,
	TableRowProps as TableRowPropsMui,
} from '@mui/material';

import styled from 'styled-components';

type TableRowProps = TableRowPropsMui & {
	key: string;
	onClick: () => void;
};

const StyledTableRow = styled(TableRowMui)`
	position: relative;
	background: white;
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
	cursor: pointer;
	& > td {
		padding-top: 14px !important;
		padding-bottom: 14px !important;
		padding-left: 20px !important;
		padding-right: 20px !important;
	}
	& > td > span {
		white-space: nowrap !important;
	}
`;

const TableRowContent: React.FC<TableRowProps> = props => {
	return <StyledTableRow {...props}>{props.children}</StyledTableRow>;
};

export default TableRowContent;
